/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_SubtitleInputs */

const en_wc_dl_subtitle = /** @type {(inputs: Wc_Dl_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free for every platform. Pick your system below. Every link goes straight to the official ArtCraft WordCraft release on GitHub.`)
};

/**
* | output |
* | --- |
* | "Free for every platform. Pick your system below. Every link goes straight to the official ArtCraft WordCraft release on GitHub." |
*
* @param {Wc_Dl_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_subtitle = /** @type {((inputs?: Wc_Dl_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_subtitle(inputs)
});
export { wc_dl_subtitle as "wc.dl.subtitle" }